import React, { Component } from 'react';
import ReactECharts from 'echarts-for-react';
import API from '../../api/api';
import TimePickerRange from '../components/timePickerRange/timePickerRange';
import './tourStatistical.less';
import zhCN from 'antd/es/locale/zh_CN';
import { Tabs, Table, Button, DatePicker, Select, message, ConfigProvider } from 'antd';
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;
const key = 'updatable';

class TourStatistical extends Component {
    constructor(props) {
        super(props);
        this.tabOnChangeCallback = this.tabOnChangeCallback.bind(this);
        this.timePickerRangeChange = this.timePickerRangeChange.bind(this);
        this.onChartReadyCallback = this.onChartReadyCallback.bind(this);
    }
    state = {

        activeKey: '1',
        loading: false,
        qrTypeList: [],
        guideList: [], //导览使用 列表数据
        lotteryList: [], //优惠券 列表数据
        lotteryClick: '',
        collectZan: '',

        columnsGuideList: [//导览使用数据
            {
                title: '用户ID',
                dataIndex: 'userId',
                key: 'userId',
            },
            {
                title: '用户电话',
                dataIndex: 'userPhone',
                key: 'userPhone',
            },
            {
                title: '注册日期',
                dataIndex: 'registerTime',
                key: 'registerTime',
            },
            {
                title: '类型',
                dataIndex: 'type',
                key: 'type',
            },
            {
                title: '二维码编号',
                dataIndex: 'qrType',
                key: 'qrType',
            },
            {
                title: '激活日期',
                dataIndex: 'activeTime',
                key: 'activeTime',
            },
            {
                title: '设备',
                dataIndex: 'platform',
                key: 'platform'
            },
        ],
        columnsLotteryList: [//优惠券使用数据
            {
                title: '用户ID',
                dataIndex: 'userId',
                key: 'userId',
            },
            {
                title: '用户电话',
                dataIndex: 'userPhone',
                key: 'userPhone',
            },
            {
                title: '注册时间',
                dataIndex: 'registerTime',
                key: 'registerTime',
            },
            {
                title: '优惠券',
                dataIndex: 'couponName',
                key: 'couponName',
            },
            {
                title: '领取日期',
                dataIndex: 'gatherTime',
                key: 'gatherTime',
            },
            {
                title: '使用日期',
                dataIndex: 'useTime',
                key: 'useTime'
            },
        ],

        guideListSearchCondition: {//导览使用数据搜索条件
            qrType: '全部',
            startTime: '',
            endTime: '',
            startDate: '',
            endDate: '',
            pageNum: 1,
            pageSize: 5,
        },

        clickBannerSearchCondition: {//活动点击数量 搜索条件
            startTime: '',
            endTime: '',
            startDate: '',
            endDate: '',
            type: 0,
        },

        lotterySearchCondition: {//抽奖领券 搜索条件
            startTime: '',
            endTime: '',
            startDate: '',
            endDate: '',
            useStartDate: '',
            useEndDate: '',
            couponType: 0,
            pageNum: 1,
            pageSize: 5
        },

        pagination1: {
            hideOnSinglePage: true,
            showQuickJumper: false,
            showSizeChanger: false,
            addModalTitle: '',
            pageSize: 5,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
        },
        pagination3: {
            hideOnSinglePage: true,
            showQuickJumper: false,
            showSizeChanger: false,
            addModalTitle: '',
            pageSize: 5,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
        },

        ReactEChartsOption1: {
            title: {
                text: ''
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['激活数']
            },
            grid: {
                left: '10%',
                right: '10%',
                bottom: '10%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: []
            },
            yAxis: {
                type: 'value',
            },
            series: [
                {
                    name: '激活数',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    data: []
                }
            ]
        },
        ReactEChartsOption2: {
            title: {
                text: ''
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['抽奖', '集赞']
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: []
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    name: '抽奖',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    data: []
                },
                {
                    name: '集赞',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    data: []
                }
            ]
        },
        ReactEChartsOption3: {
            title: {
                text: ''
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['领取', '核销']
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: []
            },
            yAxis: {
                type: 'value',
            },
            series: [
                {
                    name: '领取',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    data: []
                },
                {
                    name: '核销',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    data: []
                }
            ]
        }
    }

    componentDidMount() {
        this.greatWallQrType();
    }

    async greatWallQrType() {
        let result = await API.greatWallQrType()
        if (result.status == 1) {
            let qrTypeList = result.data.qrTypeList;
            this.setState({ qrTypeList })
            return;
        }
    }

    tabOnChangeCallback(key) {
        this.setState({ activeKey: key }, () => {
            // this.getListData()
        })
    }

    timePickerRangeChange(timeObj) {
        let { guideListSearchCondition, clickBannerSearchCondition, lotterySearchCondition } = this.state;
        console.log('timeObj', timeObj)
        if (timeObj.start) {
            eval(`${timeObj.type}.startTime = timeObj.start`);
        }
        if (timeObj.end) {
            eval(`${timeObj.type}.endTime = timeObj.end`);
        }
        this.setState({ guideListSearchCondition, clickBannerSearchCondition, lotterySearchCondition })
    }

    searchForData(type) {//查询
        message.loading({ content: '查询中...', key });
        const {
            guideListSearchCondition,
            clickBannerSearchCondition,
            lotterySearchCondition,
        } = this.state;
        eval(type + '.pageNum=1');
        this.setState({
            guideListSearchCondition,
            clickBannerSearchCondition,
            lotterySearchCondition
        }, () => {
            this.getListData('search');
        })
    }

    searchReset(type) { // 重新
        let guideListSearchCondition = {
            qrType: '全部',
            startTime: '',
            endTime: '',
            startDate: '',
            endDate: '',
            pageNum: 1,
            pageSize: 5,
        }
        this.setState({
            guideListSearchCondition,
        }, () => {
            this.getListData();
        })
    }

    onChartReadyCallback() {
        console.log('onChartReadyCallback')
    }

    async getListData(type) {
        const { activeKey, guideListSearchCondition, clickBannerSearchCondition, lotterySearchCondition, pagination1, pagination3 } = this.state;
        let result;
        switch (activeKey) {
            case '1':
                result = await API.greatWallGuide(guideListSearchCondition);
                if ('search' == type) {
                    message.success({ content: '成功', key, duration: 0.6 });
                }
                if (result.status == 1) {
                    let { dayNum, totalNum, guideList } = result.data;
                    let { pagination1 } = this.state;
                    let ObjectKeys = dayNum.map((item) => {
                        return item.dayTime
                    })
                    let ObjectValues = dayNum.map((item) => {
                        return item.num
                    })
                    console.log('ObjectKeys', ObjectKeys)
                    console.log('ObjectValues', ObjectValues)
                    pagination1.total = Number(totalNum);
                    pagination1.current = guideListSearchCondition.pageNum;
                    let ReactEChartsOption1 = {
                        title: {
                            text: ''
                        },
                        tooltip: {
                            trigger: 'axis'
                        },
                        legend: {
                            data: ['激活数']
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: ObjectKeys
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                            {
                                name: '激活数',
                                type: 'line',
                                stack: 'Total',
                                label: {
                                    show: true,
                                    position: 'top'
                                },
                                data: ObjectValues
                            }
                        ]
                    }
                    this.setState({
                        ReactEChartsOption1,
                        guideList,
                        pagination1
                    })
                }
                break;
            case '2':
                if (clickBannerSearchCondition.type == 1) {
                    if (!clickBannerSearchCondition.startDate || !clickBannerSearchCondition.endDate) {
                        message.success({ content: '请选择日期', key, duration: 0.6 });
                        return
                    }
                }
                result = await API.greatWallClickBanner(clickBannerSearchCondition);
                if (!result) return;
                if (result.status != 1) {
                    message.success({ content: result.msg, key, duration: 1 });
                    return
                }
                if (result.status == 1 && 'search' == type) {
                    message.success({ content: '成功', key, duration: 1 });
                }

                if (result.status == 1) {
                    let { lotteryDayNum, zanDayNum, lotteryClick, collectZan } = result.data;
                    if (clickBannerSearchCondition.type == 1) {
                        this.setState({
                            activityData: result.data,
                        })
                    } else {
                        let ObjectKeys = lotteryDayNum.map((item) => {
                            return item.dayTime
                        })
                        let lotteryValue = lotteryDayNum.map((item) => {
                            return item.num
                        })
                        let zanValue = zanDayNum.map((item) => {
                            return item.num
                        })
                        let ReactEChartsOption2 = {
                            title: {
                                text: ''
                            },
                            tooltip: {
                                trigger: 'axis'
                            },
                            legend: {
                                data: ['抽奖', '集赞']
                            },
                            grid: {
                                left: '3%',
                                right: '4%',
                                bottom: '3%',
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                boundaryGap: false,
                                data: ObjectKeys
                            },
                            yAxis: {
                                type: 'value'
                            },
                            series: [
                                {
                                    name: '抽奖',
                                    type: 'line',
                                    label: {
                                        show: true,
                                        position: 'top'
                                    },
                                    data: lotteryValue
                                },
                                {
                                    name: '集赞',
                                    type: 'line',
                                    label: {
                                        show: true,
                                        position: 'top'
                                    },
                                    data: zanValue
                                }
                            ]
                        }
                        this.setState({
                            ReactEChartsOption2,
                            lotteryClick,
                            collectZan,
                            activityData: result.data,
                        })
                    }
                }
                break;
            case '3':
                result = await API.greatWallLottery(lotterySearchCondition);
                if ('search' == type) {
                    message.success({ content: '成功', key, duration: 1 });
                }
                if (result.status == 1) {
                    let { totalNum, gatherDayNum, useDayNum, lotteryList } = result.data;
                    let { pagination3 } = this.state;
                    let ObjectKeys = gatherDayNum.map((item) => {
                        return item.dayTime
                    })
                    let gatherValue = gatherDayNum.map((item) => {
                        return item.num
                    })
                    let useValue = useDayNum.map((item) => {
                        return item.num
                    })
                    pagination3.total = Number(totalNum);
                    pagination3.current = lotterySearchCondition.pageNum;
                    let ReactEChartsOption3 = {
                        title: {
                            text: ''
                        },
                        tooltip: {
                            trigger: 'axis'
                        },
                        legend: {
                            data: ['领取', '核销']
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: ObjectKeys
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                            {
                                name: '领取',
                                type: 'line',
                                label: {
                                    show: true,
                                    position: 'top'
                                },
                                data: gatherValue
                            },
                            {
                                name: '核销',
                                type: 'line',
                                label: {
                                    show: true,
                                    position: 'top'
                                },
                                data: useValue
                            }
                        ]
                    }
                    this.setState({
                        ReactEChartsOption3,
                        lotteryList,
                        pagination3
                    })
                }
                break;
        }
    }

    onSearchDateChange(type, date) {
        console.log(type)
        let {
            guideListSearchCondition,
            clickBannerSearchCondition,
            lotterySearchCondition
        } = this.state;

        let startTime = '', endTime = '';
        if (date.length == 0) {
            startTime = ''; endTime = '';
        } else {
            // startTime = Math.floor(date[0].valueOf() / 1000);
            // endTime = Math.floor(date[1].valueOf() / 1000);
            startTime = date[0].format('YYYY-MM-DD');
            endTime = date[1].format('YYYY-MM-DD');
        }

        switch (type) {
            case 'activationDate':
                guideListSearchCondition.startDate = startTime;
                guideListSearchCondition.endDate = endTime;
                break;
            case 'activityDate':
                clickBannerSearchCondition.startDate = startTime;
                clickBannerSearchCondition.endDate = endTime;
                break;
            case 'couponDate':
                lotterySearchCondition.startDate = startTime;
                lotterySearchCondition.endDate = endTime;
                break;
            case 'couponUseDate':
                lotterySearchCondition.startDate = startTime;
                lotterySearchCondition.endDate = endTime;
                break;
        }

        this.setState({
            guideListSearchCondition,
            clickBannerSearchCondition,
            lotterySearchCondition,
        });
        console.log('guideListSearchCondition', guideListSearchCondition, clickBannerSearchCondition, lotterySearchCondition);
    }

    onSelectChange(type, target, value) {//下拉框更改
        const {
            guideListSearchCondition,
            lotterySearchCondition,
            clickBannerSearchCondition,
        } = this.state;
        eval(type + '.' + target + '=value');
        this.setState({
            guideListSearchCondition,
            lotterySearchCondition,
            clickBannerSearchCondition
        }, () => {
            if (type == 'clickBannerSearchCondition') {
                {
                    this.searchForData('clickBannerSearchCondition')
                }
            }
        });
    }

    handleTableChange = (pagination, filters, sorter) => {
        const {
            activeKey,
            guideListSearchCondition,
            lotterySearchCondition
        } = this.state;
        let conditionArr = ['guideListSearchCondition', '', 'lotterySearchCondition']
        eval(conditionArr[activeKey - 1] + '.pageNum=' + pagination.current)
        if (activeKey == 1) {
            this.setState({ pagination1: pagination, guideListSearchCondition }, () => {
                this.getListData();
            })
        }
        if (activeKey == 3) {
            this.setState({ pagination3: pagination, lotterySearchCondition }, () => {
                this.getListData();
            })
        }
    };

    render() {
        const {
            activeKey,
            pagination1,
            pagination3,

            qrTypeList,
            columnsGuideList,
            guideList,
            guideListSearchCondition,
            ReactEChartsOption1,

            clickBannerSearchCondition,
            ReactEChartsOption2,
            lotteryClick,
            collectZan,
            activityData,

            lotterySearchCondition,
            columnsLotteryList,
            ReactEChartsOption3,
            lotteryList,

        } = this.state;
        return (
            <ConfigProvider locale={zhCN}>
                <div className="TourStatistical">
                    <Tabs activeKey={activeKey} onChange={this.tabOnChangeCallback}>
                        <TabPane tab="导览使用数据" key="1">
                            <div className="searchPane">
                                <div className="leftCondition">
                                    <RangePicker
                                        placeholder={['激活开始日期', '激活结束日期']}
                                        className="rangePicker"
                                        format="YYYY-MM-DD"
                                        onChange={this.onSearchDateChange.bind(this, 'activationDate')}
                                    ></RangePicker>
                                    <TimePickerRange type='guideListSearchCondition' onChange={this.timePickerRangeChange} />
                                    <div className="inputPane">
                                        <Select className="selectBlock" defaultValue={guideListSearchCondition.qrType} onChange={this.onSelectChange.bind(this, 'guideListSearchCondition', 'qrType')}>
                                            {
                                                qrTypeList && qrTypeList.length > 0 &&
                                                qrTypeList.map((item, index) => <Option key={index} value={item}>{item}</Option>)
                                            }
                                        </Select>
                                    </div>
                                    <Button onClick={this.searchForData.bind(this, 'guideListSearchCondition')}>查询</Button>
                                </div>
                                {/* <Button onClick={this.searchReset.bind(this, 'navigationQuery')}>重置</Button> */}
                            </div>
                            <ReactECharts
                                option={ReactEChartsOption1}
                                notMerge={true}
                                lazyUpdate={true}
                                theme={"theme_name"}
                                onChartReady={this.onChartReadyCallback}
                                // onEvents={EventsDict}
                                opts={{ renderer: 'canvas' }}
                            />
                            <Table
                                columns={columnsGuideList}
                                dataSource={guideList}
                                pagination={pagination1}
                                onChange={this.handleTableChange}
                                rowKey={(row, index) => 'activationList' + row.showId + '-' + index}
                            />
                        </TabPane>
                        <TabPane tab="活动数据" key="2">
                            <div className='activityType'>
                                <Select className="selectBlock" defaultValue={clickBannerSearchCondition.type} onChange={this.onSelectChange.bind(this, 'clickBannerSearchCondition', 'type')}>
                                    <Option value={1}>口罩</Option>
                                    <Option value={0}>抽奖集赞</Option>
                                </Select>
                            </div>
                            <div className="searchPane">
                                <div className="leftCondition">
                                    <RangePicker
                                        className="rangePicker"
                                        format="YYYY-MM-DD"
                                        onChange={this.onSearchDateChange.bind(this, 'activityDate')}
                                    ></RangePicker>
                                    <TimePickerRange type='clickBannerSearchCondition' onChange={this.timePickerRangeChange} />
                                    <Button onClick={this.searchForData.bind(this, 'clickBannerSearchCondition')}>查询</Button>
                                </div>
                                {/* <Button onClick={this.searchReset.bind(this, 'navigationQuery')}>重置</Button> */}
                            </div>
                            {
                                clickBannerSearchCondition.type == 1 &&
                                <div className='activityData'>
                                    <div>
                                        <span>口罩banner点击人数：{activityData && activityData.maskBannerUserNum}</span>
                                        <span>口罩banner点击次数：{activityData && activityData.maskBannerClickNum}</span>
                                    </div>
                                    <div>
                                        <span>二维码1扫码人数：{activityData && activityData.qrOneNum}</span>
                                        <span>二维码2扫码人数：{activityData && activityData.qrTwoNum}</span>
                                    </div>
                                    <div>
                                        <span>点击加入群聊人数：{activityData && activityData.joinGroupUserNum}</span>
                                        <span>点击加入群聊次数：{activityData && activityData.joinGroupClickNum}</span>
                                    </div>
                                    <div>
                                        <span>群聊发照片人数：{activityData && activityData.sendPicNum}</span>
                                    </div>
                                    <div>
                                        <span>邀请朋友banner点击人数：{activityData && activityData.inviteBannerUserNum}</span>
                                        <span>邀请朋友banner点击次数：{activityData && activityData.inviteBannerClickNum}</span>
                                    </div>
                                    <div>
                                        <span>发起邀请人数：{activityData && activityData.sendInviteNum}</span>
                                        <span>发起邀请次数：{activityData && activityData.sendInviteTime}</span>
                                        <span>邀请成功人数：{activityData && activityData.inviteSuccessNum}</span>
                                    </div>
                                    <div>
                                        <span>参加口罩活动的人数：{activityData && activityData.joinMaskActivityNum}</span>
                                    </div>
                                    <div>
                                        <span>群内聊天次数：{activityData && activityData.talkNum}</span>
                                        <span>群内聊天人数：{activityData && activityData.talkUserNum}</span>
                                    </div>
                                    <div>
                                        <span>15群发照片次数：{activityData && activityData.sendPicNum15}</span>
                                        <span>15群发照片人数：{activityData && activityData.sendPicUserNum15}</span>
                                    </div>
                                    <div>
                                        <span>所有群发照片的总次数：{activityData && activityData.sendPicAllNum}</span>
                                    </div>
                                    <div>
                                        <span>获得美团券人数：{activityData && activityData.meituanNum}</span>
                                        <span>使用美团券人数：{activityData && activityData.meituanUseNum}</span>
                                    </div>
                                    <div>
                                        <span>15群获得美团券人数：{activityData && activityData.meituanNum15}</span>
                                        <span>15群使用美团券人数：{activityData && activityData.meituanUseNum15}</span>
                                    </div>
                                    <div>
                                        <span>15群内聊天次数：{activityData && activityData.talkNum15}</span>
                                        <span>15群内聊天人数：{activityData && activityData.talkUserNum15}</span>
                                    </div>
                                </div>
                            }
                            {
                                clickBannerSearchCondition.type == 0 &&
                                <ReactECharts
                                    option={ReactEChartsOption2}
                                    notMerge={true}
                                    lazyUpdate={true}
                                    theme={"theme_name"}
                                    onChartReady={this.onChartReadyCallback}
                                    // onEvents={EventsDict}
                                    opts={{ renderer: 'canvas' }}
                                />
                            }
                            {
                                clickBannerSearchCondition.type == 0 &&
                                <div className='activityData'>
                                    <span>抽奖banner总点击数量：{lotteryClick}</span>
                                    <span>集赞banner总点击数量：{collectZan}</span>
                                </div>
                            }
                        </TabPane>

                        <TabPane tab="优惠券数据" key="3">
                            <div className="searchPane">
                                <div className="leftCondition">
                                    <RangePicker
                                        placeholder={['激活开始日期', '激活结束日期']}
                                        className="rangePicker"
                                        format="YYYY-MM-DD"
                                        onChange={this.onSearchDateChange.bind(this, 'couponDate')}
                                    ></RangePicker>
                                    <TimePickerRange type='lotterySearchCondition' onChange={this.timePickerRangeChange} />
                                    <RangePicker
                                        placeholder={['使用开始日期', '使用结束日期']}
                                        className="rangePicker"
                                        format="YYYY-MM-DD"
                                        onChange={this.onSearchDateChange.bind(this, 'couponUseDate')}
                                    ></RangePicker>
                                    <div className="inputPane">
                                        <Select className="selectBlock" defaultValue={lotterySearchCondition.couponType} onChange={this.onSelectChange.bind(this, 'lotterySearchCondition', 'couponType')}>
                                            <Option value={0}>全部</Option>
                                            <Option value={1}>现金红包</Option>
                                            <Option value={2}>5元美团券</Option>
                                            <Option value={3}>5元电影券</Option>
                                            <Option value={4}>10元美团券</Option>
                                            <Option value={5}>10元电影券</Option>
                                            <Option value={6}>50元美团券</Option>
                                        </Select>
                                    </div>
                                    <Button onClick={this.searchForData.bind(this, 'lotterySearchCondition')}>查询</Button>
                                </div>
                                {/* <Button onClick={this.searchReset.bind(this, 'navigationQuery')}>重置</Button> */}
                            </div>
                            <ReactECharts
                                option={ReactEChartsOption3}
                                notMerge={true}
                                lazyUpdate={true}
                                theme={"theme_name"}
                                onChartReady={this.onChartReadyCallback}
                                // onEvents={EventsDict}
                                opts={{ renderer: 'canvas' }}
                            />
                            <Table
                                columns={columnsLotteryList}
                                dataSource={lotteryList}
                                pagination={pagination3}
                                onChange={this.handleTableChange}
                                rowKey={(row, index) => 'activationList' + row.showId + '-' + index}
                            />
                        </TabPane>
                    </Tabs>
                </div>
            </ConfigProvider>
        )
    }
}

export default TourStatistical;